import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class UserController extends Controller {
  static targets = ["customerSelect", "constructionSelect"];

  static values = {
    customer: String,
  };

  connect() {
    this.initCustomerSelect();
    this.initConstructionSelect();
  }

  initCustomerSelect() {
    new SlimSelect({
      select: this.customerSelectTarget,
      placeholder: "Escolha...",
      searchText: "Nenhum resultado...",
      searchPlaceholder: "Pesquise...",
      addToBody: true,
      allowDeselect: true,
      onChange: async (customer) => {
        const customer_id = Number(customer.value);
        if (customer_id) {
          await this.enableConstructionSelect(customer_id);
        }
      },
    });
  }

  initConstructionSelect() {
    this.constructionsSlimSelect = new SlimSelect({
      select: this.constructionSelectTarget,
      placeholder: "Escolha...",
      searchText: "Nenhum resultado...",
      searchPlaceholder: "Pesquise...",
      addToBody: true,
      allowDeselect: true,
    });

    if (!this.customerSelectTarget.value) {
      this.constructionsSlimSelect.disable();
    }
  }

  async enableConstructionSelect(customer_id) {
    const constructionsData = await this.searchConstructions(customer_id);
    this.constructionsSlimSelect.setData(constructionsData);
    if (this.selectedConstructionsValue?.length)
      this.constructionsSlimSelect.setSelected(this.selectedConstructionsValue);
    this.constructionsSlimSelect.enable();
  }

  async searchConstructions(customer_id) {
    var url_string = "/admin/constructions/slim_select_search";

    const url = new URL(url_string, document.baseURI);
    url.searchParams.append("customer_id", customer_id);

    const response = await fetch(url);
    const data = await response.json();

    return data;
  }
}
